import React from 'react'
import { useAuth } from '@isdd/metais-common/contexts/auth/authContext'

import { useGetEntityParamsFromUrl } from '@/componentHelpers/ci'
import { ProjectDocumentsListContainer } from '@/components/containers/ProjectDocumentListContainer'
import { ProjectDocumentsTab } from '@/components/views/documents/ProjectDocumentsTab'
import { DocumentsListContainer } from '@/components/containers/DocumentListContainer'
import { DocumentsTable } from '@/components/views/documents/DocumentsTable'
import { ProjectDocumentsPermissionsWrapper } from '@/components/permissions/ProjectDocumentsPermissionsWrapper'

const ProjectDocumentsListPage: React.FC = () => {
    const { entityId } = useGetEntityParamsFromUrl()
    const {
        state: { user },
    } = useAuth()

    return (
        <>
            {user ? (
                <ProjectDocumentsListContainer
                    configurationItemId={entityId}
                    View={(props) => {
                        return (
                            <ProjectDocumentsPermissionsWrapper projectData={props.projectData} projectRoles={props.ciTypeData?.roleList ?? []}>
                                <ProjectDocumentsTab {...props} />
                            </ProjectDocumentsPermissionsWrapper>
                        )
                    }}
                />
            ) : (
                <DocumentsListContainer
                    configurationItemId={entityId}
                    View={(props) => {
                        return (
                            <ProjectDocumentsPermissionsWrapper projectData={props.ciData} projectRoles={props.ciTypeData?.roleList ?? []}>
                                <DocumentsTable {...props} />
                            </ProjectDocumentsPermissionsWrapper>
                        )
                    }}
                />
            )}
        </>
    )
}

export default ProjectDocumentsListPage
